// ---------------------------------------------------------------------------
// Nowee Sambade Consulting — entry point
//
// Bootstrap 5 has no jQuery dependency, so this is all the JavaScript the
// site needs: the collapse plugin for the mobile navbar, and scrollspy for
// highlighting the active section.
// ---------------------------------------------------------------------------

import './styles/app.scss';

import { Collapse, ScrollSpy } from 'bootstrap';

// Collapse — mobile navbar toggle
document.querySelectorAll('.collapse').forEach((el) => {
    Collapse.getOrCreateInstance(el, { toggle: false });
});

// ScrollSpy — declared on <body> via data-bs-spy, instantiated here so it
// initialises reliably regardless of script load order.
const spyTarget = document.querySelector('[data-bs-spy="scroll"]');
if (spyTarget) {
    ScrollSpy.getOrCreateInstance(spyTarget);
}

// Collapse the mobile menu after a nav link is tapped.
const navbar = document.querySelector('#navbarSupportedContent');
if (navbar) {
    navbar.querySelectorAll('.nav-link').forEach((link) => {
        link.addEventListener('click', () => {
            if (navbar.classList.contains('show')) {
                Collapse.getOrCreateInstance(navbar, { toggle: false }).hide();
            }
        });
    });
}
